/* ---------------------------------------------------------------------------
   STATIONED kit form — size matrix, adder calculation, add-to-cart.
   Pairs with sections/stationed-kit-pdp.liquid. Change the ladder in one, change
   it in the other: the Liquid renders what the customer READS, this decides
   what they are CHARGED.

   Approved ladder (2026-09-05) — keep in sync with kstmyze-inbound/CLAUDE.md:

       S–XL      +$0.00
       2XL       +$2.50
       3XL–6XL   +$4.50
       Tall      +$2.50 ON TOP OF the rung above

   Tall is a SURCHARGE, not a replacement: a 2XLT pays the 2XL rung AND the tall
   surcharge ($5.00); a 3XLT pays the 3XL–6XL rung AND tall ($7.00). Encoding
   that as a flag on each size is what stops "tall" being treated as its own
   flat rate, which under-bills every 2XLT and 3XLT.

   Sizes run to 5XL and to 4XLT. 6XL is not offered on a kit — see the section file.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CONFIG = {
    targetQty: 24,
    // Numeric VARIANT ids (not product ids). Created as DRAFT products
    // 2026-09-06 — the form refuses to submit any order containing an extended
    // or tall size if these are null, rather than silently under-billing.
    // NOTE: the adder products must be ACTIVE for /cart/add.js to accept them.
    adder2xlId: 54715335409888,      // stationed-size-2xl        $2.50
    adder3xl6xlId: 54715335442656,   // stationed-size-3xl-6xl    $4.50
    adderTallId: 54715335475424,     // stationed-size-tall       $2.50
    // Per-KIT add-on locations. Flat price, quantity 1 — not per piece.
    addonChestId: 54722221048032,    // stationed-addon-chest    $79.00
    addonSleeveId: 54722221080800    // stationed-addon-sleeve   $79.00
  };

  /* size -> { rung, tall }. `tall: true` STACKS on top of `rung`. */
  var SIZE_TABLE = {
    'S': { rung: null, tall: false },
    'M': { rung: null, tall: false },
    'L': { rung: null, tall: false },
    'XL': { rung: null, tall: false },
    '2XL': { rung: 'a2xl', tall: false },
    '3XL': { rung: 'a3xl6xl', tall: false },
    '4XL': { rung: 'a3xl6xl', tall: false },
    '5XL': { rung: 'a3xl6xl', tall: false },
    '6XL': { rung: 'a3xl6xl', tall: false },
    'LT': { rung: null, tall: true },
    'XLT': { rung: null, tall: true },
    '2XLT': { rung: 'a2xl', tall: true },
    '3XLT': { rung: 'a3xl6xl', tall: true },
    '4XLT': { rung: 'a3xl6xl', tall: true }
  };

  var PRICE = { a2xl: 2.50, a3xl6xl: 4.50, tall: 2.50 };
  var VARIANT = { a2xl: 'adder2xlId', a3xl6xl: 'adder3xl6xlId', tall: 'adderTallId' };

  /* Which sizes a garment can actually be fulfilled in, and whether it has a
     sleeve to print on. Offering a size the chosen blank is not made in is how
     an order gets taken and then cannot ship, so the matrix disables them
     instead of trusting the copy.

     Verified against the SanMar catalog 2026-09-07 (cost is case price, S-XL):
       PC54  Core Cotton ......... 5.4oz, S-6XL, 114 colors, $2.44  <- standard
       PC450 Fan Favorite ........ 4.5oz, S-6XL,  53 colors, $2.89  <- softer ringspun
       PC61  Essential ........... 6.1oz, S-6XL,  62 colors, $3.02  <- heavyweight
       PC54SL Core Cotton SL ..... 5.4oz, S-4XL,   7 colors, $3.69  <- sleeveless
     Tall comes from the matching T-body (PC54T / PC61T, LT-4XLT). Two blanks
     carry a restriction and both are enforced below rather than in prose:
       - PC450 has no tall body. SanMar returns "Invalid style" for PC450T.
       - PC54SL stops at 4XL and, being sleeveless, cannot take a sleeve print.
     PC54SL is deliberately the same 5.4oz Core Cotton fabric and dye lot as the
     standard tee, so a crew running mixed sleeved and sleeveless matches. */
  var GARMENT_LIMITS = [
    { match: /fan favorite|pc450/i,
      allow: ['S','M','L','XL','2XL','3XL','4XL','5XL','6XL'],
      note: 'The Fan Favorite is not made in tall sizes. Everything up to 6XL is available.' },
    { match: /sleeveless|pc54sl/i,
      allow: ['S','M','L','XL','2XL','3XL','4XL'],
      noSleeve: true,
      note: 'The sleeveless tee runs S–4XL, with no tall sizes and no sleeve to print on.' }
  ];

  function limitsFor(label) {
    for (var i = 0; i < GARMENT_LIMITS.length; i++) {
      if (GARMENT_LIMITS[i].match.test(label || '')) return GARMENT_LIMITS[i];
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('stationed-form');
    if (!form) return;

    var submitBtn = document.getElementById('submit-btn');
    var counter = document.getElementById('matrix-counter');
    var adderOut = document.getElementById('stationed-adder-total');
    var errorOut = document.getElementById('stationed-error');
    var activeImg = document.getElementById('stationed-active-img');
    var inkEl = document.getElementById('ink-color');
    var chestEl = document.getElementById('addon-chest');
    var sleeveEl = document.getElementById('addon-sleeve');
    var sleeveArtEl = document.getElementById('addon-sleeve-art');

    // The sleeve artwork choice only matters once the sleeve print is ticked.
    function syncSleeve() {
      if (sleeveArtEl && sleeveEl) sleeveArtEl.hidden = !sleeveEl.checked;
    }
    if (sleeveEl) { sleeveEl.addEventListener('change', syncSleeve); syncSleeve(); }

    /* ---- gallery ---- */
    var thumbs = document.querySelectorAll('.thumb-btn');
    Array.prototype.forEach.call(thumbs, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(thumbs, function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (activeImg) activeImg.src = btn.dataset.src;
      });
    });

    /* ---- matrix ---- */
    function evaluate() {
      var counts = { a2xl: 0, a3xl6xl: 0, tall: 0 };
      var parts = [];
      var total = 0;
      var unknown = null;

      Array.prototype.forEach.call(document.querySelectorAll('.size-input'), function (input) {
        var qty = parseInt(input.value, 10) || 0;
        if (qty <= 0) return;
        var size = input.dataset.size;
        var rules = SIZE_TABLE[size];
        // Fail loud. An unlisted size would otherwise ship at the base rate.
        if (!rules) { unknown = size; return; }
        total += qty;
        parts.push(size + ': ' + qty);
        if (rules.rung) counts[rules.rung] += qty;
        if (rules.tall) counts.tall += qty;
      });

      var adderTotal = counts.a2xl * PRICE.a2xl
                     + counts.a3xl6xl * PRICE.a3xl6xl
                     + counts.tall * PRICE.tall;

      // Any surcharge owed needs its variant id configured, or we would add a
      // kit to the cart and charge nothing for the extended sizes.
      var missingId = null;
      Object.keys(counts).forEach(function (k) {
        if (counts[k] > 0 && !CONFIG[VARIANT[k]]) missingId = k;
      });

      return {
        total: total, counts: counts, adderTotal: adderTotal,
        unknown: unknown, missingId: missingId, breakdown: parts.join(', ')
      };
    }

    function refresh() {
      var r = evaluate();
      if (counter) counter.textContent = r.total + ' / ' + CONFIG.targetQty + ' selected';
      if (adderOut) {
        adderOut.textContent = r.adderTotal > 0
          ? 'Extended and tall sizes: +$' + r.adderTotal.toFixed(2)
          : '';
      }

      if (r.unknown) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Unrecognized size "' + r.unknown + '" — contact us';
      } else if (r.missingId) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Extended sizes unavailable online — contact us';
      } else if (r.total !== CONFIG.targetQty) {
        submitBtn.disabled = true;
        submitBtn.textContent =
          'Select ' + CONFIG.targetQty + ' pieces (currently ' + r.total + ')';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add 24-piece kit to cart';
      }
      return r;
    }

    function fail(message) {
      if (errorOut) { errorOut.textContent = message; errorOut.hidden = false; }
      refresh();
    }

    /* ---- role wording: a dropdown, with a free-text escape hatch ---- */
    var roleSelect = document.getElementById('role-select');
    var roleCustom = document.getElementById('role-custom');

    function syncRole() {
      if (!roleSelect || !roleCustom) return;
      var custom = roleSelect.value === '__custom__';
      roleCustom.hidden = !custom;
      if (custom && document.activeElement === roleSelect) roleCustom.focus();
    }
    if (roleSelect) {
      roleSelect.addEventListener('change', syncRole);
      syncRole();
    }

    /** The wording actually printed, or '' if the kit has no role print. */
    function roleValue() {
      if (!roleSelect) return '';
      if (roleSelect.value === '__custom__') {
        return roleCustom ? roleCustom.value.trim().toUpperCase() : '';
      }
      return roleSelect.value;
    }

    /* ---- garment-aware size availability ---- */
    var variantSelect = document.getElementById('variant-select');
    var limitNote = document.getElementById('garment-limit-note');
    var backGroup = document.getElementById('back-text-group');

    /* A front-only kit has no back print, so asking for back wording collects a
       value that will never be printed - and a customer who typed SECURITY there
       would reasonably expect to see it on the shirt. Hide it, and stop it
       reaching the cart, whenever the chosen variant is front only. */
    function applyPrintScope(label) {
      var frontOnly = /front only/i.test(label || '');
      if (backGroup) backGroup.hidden = frontOnly;
      return frontOnly;
    }

    function applyGarmentLimits() {
      var label = variantSelect
        ? variantSelect.options[variantSelect.selectedIndex].text
        : '';
      var lim = limitsFor(label);
      applyPrintScope(label);
      Array.prototype.forEach.call(document.querySelectorAll('.size-input'), function (input) {
        var blocked = lim && lim.allow.indexOf(input.dataset.size) === -1;
        var cell = input.closest('.matrix-cell');
        input.disabled = !!blocked;
        if (cell) cell.classList.toggle('unavailable', !!blocked);
        // Zero anything the new garment cannot be made in, so a stale count
        // never survives a garment change and reaches the cart.
        if (blocked && (parseInt(input.value, 10) || 0) > 0) input.value = '0';
      });
      if (limitNote) {
        limitNote.textContent = lim ? lim.note : '';
        limitNote.hidden = !lim;
      }
      // A sleeveless body has nowhere to put the sleeve print. Clear the choice
      // as well as disabling it, so a tick made on a sleeved garment cannot
      // survive the switch and bill for a print that cannot be produced.
      if (sleeveEl) {
        var noSleeve = !!(lim && lim.noSleeve);
        if (noSleeve && sleeveEl.checked) sleeveEl.checked = false;
        sleeveEl.disabled = noSleeve;
        var wrap = sleeveEl.closest('.addon-row');
        if (wrap) wrap.classList.toggle('addon-disabled', noSleeve);
        syncSleeve();
      }
    }
    if (variantSelect) variantSelect.addEventListener('change', applyGarmentLimits);
    applyGarmentLimits();

    form.addEventListener('input', function () {
      if (errorOut) errorOut.hidden = true;
      refresh();
    });
    form.addEventListener('change', function () {
      if (errorOut) errorOut.hidden = true;
      refresh();
    });
    refresh(); // 'input' never fires on load; set the real initial state

    /* ---- submit ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = refresh();
      if (r.total !== CONFIG.targetQty || r.unknown || r.missingId) return;

      var logo = document.getElementById('logo-url');
      var fileEl = document.getElementById('logo-file');
      var file = fileEl && fileEl.files && fileEl.files[0];
      var link = logo ? logo.value.trim() : '';

      if (!file && !link) {
        fail('Add your artwork — upload a file, or paste a link if it is over 20 MB.');
        return;
      }
      // Shopify caps a line-item file property at 20 MB. Catch it here rather
      // than letting the cart reject the whole add with an opaque error.
      if (file && file.size > 20 * 1024 * 1024) {
        fail('That file is over 20 MB. Paste a link to it instead — the field below the upload.');
        return;
      }

      var frontOnly = applyPrintScope(
        variantSelect ? variantSelect.options[variantSelect.selectedIndex].text : '');
      var role = frontOnly ? '' : roleValue();
      // A blank custom box means the buyer picked "Something else" and never
      // typed it. Stop rather than sending a kit to press with no wording.
      // Skipped entirely on a front-only kit, which has no back wording at all.
      if (!frontOnly && roleSelect && roleSelect.value === '__custom__' && !role) {
        fail('Type the wording you want printed, or pick one from the list.');
        return;
      }

      var baseId = form.querySelector('[name="base_variant_id"]').value;

      var props = {
        _bundle: 'stationed_kit',
        'Size Breakdown': r.breakdown
      };
      if (link) props['Artwork Link'] = link;
      if (role) props['Printed wording'] = role;
      if (inkEl && inkEl.value) props['Ink color'] = inkEl.value;
      if (r.adderTotal > 0) props['Extended/Tall Surcharge'] = '$' + r.adderTotal.toFixed(2);

      var adderItems = [];
      if (chestEl && chestEl.checked && CONFIG.addonChestId) {
        adderItems.push({ id: CONFIG.addonChestId, quantity: 1,
          properties: { _parent: baseId, 'Print location': 'Second chest, opposite the logo' } });
        props['Second chest print'] = 'Yes';
      }
      if (sleeveEl && sleeveEl.checked && CONFIG.addonSleeveId) {
        var art = sleeveArtEl ? sleeveArtEl.value : 'US flag';
        adderItems.push({ id: CONFIG.addonSleeveId, quantity: 1,
          properties: { _parent: baseId, 'Print location': 'Sleeve', Artwork: art } });
        props['Sleeve print'] = art;
      }
      [['a2xl', '2XL'], ['a3xl6xl', '3XL-6XL'], ['tall', 'Tall']].forEach(function (pair) {
        var key = pair[0];
        if (r.counts[key] > 0) {
          adderItems.push({
            id: CONFIG[VARIANT[key]],
            quantity: r.counts[key],
            properties: { _parent: baseId, Adder: pair[1] }
          });
        }
      });

      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
      var root = window.Shopify.routes.root;

      /* A file line-item property can ONLY travel as multipart FormData, and
         FormData adds exactly ONE line. The JSON items[] form adds many lines
         but cannot carry a file. So an upload needs two requests: the kit with
         its file, then the adders. Without a file it stays a single JSON call. */
      function addKitWithFile() {
        var fd = new FormData();
        fd.append('id', baseId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
        fd.append('properties[Artwork file]', file, file.name);
        return fetch(root + 'cart/add.js', { method: 'POST', body: fd })
          .then(function (res) {
            if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
            return res.json();
          });
      }

      function addAdders() {
        if (!adderItems.length) return Promise.resolve();
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: adderItems })
        }).then(function (res) {
          if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        });
      }

      if (file) {
        addKitWithFile().then(function (kitLine) {
          return addAdders().catch(function (err) {
            /* Adders failed but the kit is in the cart. That is an UNDER-BILLED
               order — roll the kit back rather than leave it sitting there. */
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: kitLine.key, quantity: 0 })
            }).then(function () { throw err; });
          });
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function (err) {
          console.error('[STATIONED] cart add failed', err);
          fail("We couldn't add that to your cart. Nothing has been charged — please try " +
               'again, or email us and we will place the order for you.');
        });
        return;
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: baseId, quantity: 1, properties: props }].concat(adderItems) })
      }).then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        window.location.href = '/cart';
      }).catch(function (err) {
        console.error('[STATIONED] cart add failed', err);
        fail("We couldn't add that to your cart. Nothing has been charged — " +
             'please try again, or email us and we will place the order for you.');
      });
    });
  });
})();
